/* eslint-disable tailwindcss/no-arbitrary-value */
import React from 'react';
import { ComponentCounter } from '$/(cms)/_modules/cmsService/types';

export const CounterModule: React.FC<ComponentCounter> = ({ items }) => {
  return (
    <div className="bg-gradient-to-b from-[#E0F4F8] to-[#EEE]">
      <div className="mx-auto max-w-[1536px] px-4 py-8 sm:px-6 md:px-8 md:py-10 lg:px-10 lg:py-12">
        <div className="grid grid-cols-2 gap-4 lg:grid-cols-4 lg:gap-6">
          {items.map((item, index) => (
            // eslint-disable-next-line react/no-array-index-key
            <div key={index}>
              <h3 className="font-bold text-fill/primary-dark text-4xl leading-[44px] lg:text-[56px] lg:leading-[56px]">
                {item.title}
              </h3>
              <p className="font-medium text-text/secondary text-sm leading-5 sm:text-base sm:leading-[22px] md:text-lg md:leading-6">
                {item.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};
